import React, { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { FmBasicModal, FmButton, FmRadioButton } from "../../";
import { LOGGED_IN_ROUTES } from "../../../Constants";
import { useIsMobile } from "../../../Hooks";
import { AgriSolutionState } from "../../../Redux";

import useStyles from "./FmFertilizationModal.style";
import { shareableItemTypes } from "../../../Utils/Enums";

interface FmFertilizationModalProps {
    img: any;
    isOpen: any;
    onClose: any;
}

const FmFertilizationModal = ({ img, isOpen, onClose }: FmFertilizationModalProps) => {
    const [isKnow, setIsKnow] = useState<boolean>(true);
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    const handleRadioButtonValue = (e: any) => {
        const value = e.target.value === "I know" ? true : false;
        setIsKnow(value);
    };

    const radioButtonValues = [t("fertilizationPopup.iKnow"), t("fertilizationPopup.iDontKnow")];

    const nextPage = isKnow ? LOGGED_IN_ROUTES.AGRI_SOLUTION_FORTH_STEP : LOGGED_IN_ROUTES.AGRI_SOLUTION_FIFTH_STEP;

    const onClickHandler = () => {
        dispatch(AgriSolutionState.Actions.setFarmPageCanBeNavigated(true));
        dispatch(AgriSolutionState.Actions.setCustomizePageCanBeNavigated(true));
        dispatch(AgriSolutionState.Actions.setReleaseGraphType(shareableItemTypes.agri_multicote_customize));
        history.push(nextPage);
    };

    return (
        <FmBasicModal img={img} onClose={onClose} isOpen={isOpen}>
            <div className={isMobile ? classes.mobile_rightSide : classes.rightSide}>
                <div className={classes.mobile_box}>
                    <span className={isMobile ? classes.mobile_title : classes.title}>{t("fertilizationPopup.title")}</span>
                    <span className={isMobile ? classes.mobile_subTitle : classes.subTitle}>{t("fertilizationPopup.subTitle")}</span>
                    <span className={isMobile ? classes.mobile_thirdTitle : classes.thirdTitle}>{t("fertilizationPopup.thirdTitle")}</span>
                    <div className={classes.radioButton_container}>
                        <FmRadioButton noMarginStart={true} values={radioButtonValues} onChange={(e: any) => handleRadioButtonValue(e)} />
                    </div>
                </div>
                <div className={classes.button_container}>
                    <FmButton fullWidth={isMobile ? "fullWidth" : "regular"} onClick={onClickHandler}>
                        {t("fertilizationPopup.next")}
                    </FmButton>
                </div>
            </div>
        </FmBasicModal>
    );
};

export default FmFertilizationModal;
